import { Fill, Track } from './TokenProgressBar.styles';

type TokenProgressBarProps = {
  percentage: number;
};

export const TokenProgressBar = ({ percentage }: TokenProgressBarProps) => (
  <Track>
    <Fill $percentage={percentage} />
  </Track>
);
